module.exports = require("./nl-CW.d.ts");